<div class="details-card-wrapper">
    <!-- heading -->
    <!-- <h2>Products in box</h2> -->

    <div class="details-card">
        <div class="details-card-body">
            <div class="det-text-products-in-box">
                <ul class="product-box-item-list">
                    @for (product of productsInABoxToShow(); track product) {
                    <li>
                        {{ product | titlecase }}
                    </li>
                    }
                </ul>

                <!-- Read More Section -->
                @if (hasMoreItems()) {
                <div class="view-more-section d-flex flex-row justify-content-end">
                    <div class="view-more-content">
                        @if (!isExpanded) {
                        <span (click)="toggleViewMoreComments()" class="view-more">View More Products</span>
                        }
                        <!-- for View Less -->
                        @if (isExpanded) {
                        <span (click)="toggleViewMoreComments()" class="view-more">View Less Products</span>
                        }
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>